import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from 'environments/environment';

import { ConstantsService } from 'app/services/constants-service';
import { EntityOtherComponent } from 'app/entities/other/entity-other.component';

@Component({
  templateUrl: './entity-time-tracking.component.html'
})

export class EntityTimeTrackingComponent extends EntityOtherComponent {

}



// WEBPACK FOOTER //
// ./src/app/entities/time-tracking/entity-time-tracking.component.ts